@if (isAuthenticated) {
  <app-header></app-header>
  <section class="page-space">
    @if ((isBpLoggedIn$ | async)===false) {
      <div class="spinner-container">
        <mat-spinner aria-label="Loading"></mat-spinner>
      </div>
    } @else {
      <div class="homepage-section">
        <div class="homepage-box mat-drawer-container mat-sidenav-content mat-drawer-transition">
          <div class="mat-drawer-content mat-sidenav-content">
            <div class="space-content container">
              <router-outlet></router-outlet>
            </div>
          </div>
        </div>
      </div>
    }
  </section>
}